<template>
  <div class='edit-website-services'>
    <page-header
      title="Edit services offered"
      :commands="editingIndex === 'NEW ITEM'
      ? [{ 
        click: () => updateEditingItem(null, null, null, null, null),
        icon: 'x', 
        text: 'Cancel new item',
        type: 'red'
      }]
      : [{ 
        click: () => updateEditingItem('NEW ITEM', '', ''),
        icon: '+', 
        text: 'Add service item'
      }]"
    />
    <div class="container">
      <p>
        Services will create custome key-pair objects. <br />
        Hover over item and click the pencil icon to edit.
      </p>
      <div class='services-list'>
        <service-list-item
          v-if="editingIndex === 'NEW ITEM'"
          :error="error"
          :index="null"
          :beingEdited="true"
          :editingKey="editingKey"
          :editingValue="editingValue"
          :descr="'Product description'"
          :serviceKey="'Service name'"
          :category="category"
          :categoryOptions="Object.keys(groupedServices)"
          :updateEditingItem="updateEditingItem"
          :handleSubmitService="handleSubmitService"
          :handleFieldChange="handleFieldChange"
          :handleDeleteItemClick="handleDeleteItemClick"
          :newCategoryValue="newCategoryValue"
        />
        <span v-for="group in Object.keys(groupedServices)" :key="group">
          <h4 v-if="group === '_noCategory'">No category</h4>
          <h4 v-else> {{ group }} </h4>
          <service-list-item
            v-for="(service, index) in groupedServices[group]"
            :error="error"
            :key="`${group}-${index}`"
            :index="index"
            :beingEdited="editingId === service.id"
            :editingKey="editingKey"
            :editingValue="editingValue"
            :id="service.id"
            :descr="service.descr"
            :category="category || service.category"
            :serviceKey="service.service"
            :categoryOptions="Object.keys(groupedServices)"
            :updateEditingItem="updateEditingItem"
            :handleSubmitService="handleSubmitService"
            :handleFieldChange="handleFieldChange"
            :handleDeleteItemClick="handleDeleteItemClick"
            :newCategoryValue="newCategoryValue"
            :group="group"
          />
        </span>
      </div>
    </div>
    <div class='container pt-10'> 
      <copy-card
          :label="'Services list all'"
          :text="servicesLink"
        />
        <p>
          <strong class='pb-0'>Services list category</strong> <br />
          {{ servicesLink }}/{category}/
        </p>
    </div>
  </div>
</template>

<script>
import CopyCard from '@/myComponents/CopyCard.vue';
import PageHeader from '../../components/PageHeader.vue';
import ServiceListItem from '../../components/ServiceListItem.vue';
import TextComponent from '../../components/TextComponent'
import { api } from '../../services/api'
export default {
  name: "edit-site-services",
  components: { ServiceListItem, CopyCard, PageHeader },
  data: function(){
    return ({
      groupedServices: {},
      error: null,
      editingIndex: null,
      editingId: null,
      editingKey: null,
      editingValue: null,
      newCategoryValue: null,
      category: null
    })
  },
  mounted: async function() {
    if (!this.servicesList.loaded) {
      this.loadServicesList()
    } else this.updateGroupedServices()
  },
  methods: {
    updateGroupedServices () {
      this.groupedServices = {}
      if (this.servicesList && this.servicesList.data) {
        this.groupedServices = this.servicesList.data
          .reduce((prev, curr) => {
              const useKey = !curr.category || curr.category === ''
                ? '_noCategory' : curr.category
              if (prev[useKey]) prev[useKey].push(curr)
              else prev[useKey] = [curr]
              return prev
            }, { '_noCategory': [] })
      }
    },
    async loadServicesList () {
      await this.$store.dispatch('getServicesList')
      this.updateGroupedServices()
    },
    updateEditingItem (editingIndex, editingKey, editingValue, editingCategory, id) {
      this.error = null
      this.editingIndex = editingIndex
      this.editingKey = editingKey
      this.editingValue = editingValue
      this.editingId = id
      this.newCategoryValue = null
      this.category = editingCategory === '_noCategory' ?
        null : editingCategory || null
    },
    async handleSubmitService () {
      const serviceItem = {
        service: this.editingKey,
        id: this.editingId || null,
        category: this.newCategoryValue || this.category,
        descr: this.editingValue
      }

      let submit = true
      if (this.category === 'New category' &&
        (!this.newCategoryValue || this.newCategoryValue.replace(/ /g, '') === '')) {
        submit = false
      }

      if (this.editingValue.replace(/ /g, '') === '' || this.editingKey.replace(/ /g, '') === ''){
        submit = false
      }

      if (!submit) {
        this.error = "Please complete all form fields."
      } else {
        this.error = null
        const dispatchKey = this.editingIndex === 'NEW ITEM'
          ? 'addServiceItem'
          : 'updateServiceItem'
        await this.$store.dispatch(dispatchKey, serviceItem)
        this.updateEditingItem(null, null, null, null, null)
        this.updateGroupedServices()
      }
    },
    handleFieldChange (key, e) {
      if (key === 'category') { 
        this[key] = (e.target.value === 'No category' || e.target.value === '_noCategory')
          ? null : e.target.value 
        this.newCategoryValue = null
      } else {
        this[key] = e.target.value
      }
    },
    handleDeleteItemClick () {
      this.$store.commit("setModal", {
        component: TextComponent,
        mounted: true,
        header: "Confirm delete",
        props: {
          text:
            "Are you sure you want to delete service " +
            this.editingKey +
            "?"
        },
        goodClick: async () => {
          const itemKey = this.editingId
          this.updateEditingItem(null, null, null, null, null)
          await this.$store.dispatch('deleteServiceItem', itemKey)
          this.updateGroupedServices()
        }
      });
    }
  },
  computed: {
    servicesLink () {
      const id = this.$store.getters.user && this.$store.getters.user.resourceid
      return `${api}/site/resources/services-list/${id || ''}`
    },
    servicesList () {
      return this.$store.getters.services
    },
    serviceKeys () {
      return Object.keys(this.servicesList.data)
    }
  }
};
</script>

<style lang="scss">
@import "../../styles/colors.scss";
.edit-website-services {
  p {
    line-height: 1.75rem;
  }
  .services-list {
    margin-top: 20px;
    input[type=text], textarea {
      background-color: $fieldBg;
      border: none;
      border-radius: 3px;
      width: calc(100% - 20px);
      box-shadow: 0 0 0 1px $fieldShadow;
      &:focus {
        background-color: $fieldBgFocus;
      }
    }
    textarea {
      height: 120px;
    }
    .edit-controls {
      width: 100%;
      button {
        margin-left: 10px;
        padding: 11px 15px;
      }
    }
  }
}
</style>
